<template>

  <div>
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner-border text-light" role="status"></div>
      <p>Cargando...</p>
    </div>
    <h5 class="fw-bold fs-4 mb-3">Registro de envío {{ tipoEnvio }}</h5>
    <form @submit.prevent="submitForm">
      <div class="row" v-if="tipoEnvio == 'exclusivo'">
        <div class="col-lg-12">
          <div class="card bg-card mt-4">
            <div class="card-header"><i class="bi bi-send"></i> Información del Envío</div>
            <div class="card-body">
              <div class="row">
                <div class="form-group col-lg-4">
                  <label class="required" for="fecha_entrega">Es Recojo +40%(Posicionamiento vehícular)</label>
                  <select v-model="form.es_recojo" name="" id="" class="form-control" @change="buscarPrecio()">
                    <option value="1">Si</option>
                    <option value="0">No</option>
                  </select>
                  <div v-if="errors.es_recojo" class="invalid-feedback">
                    {{ errors.es_recojo }}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="card bg-card mt-4">
            <div class="card-header"><i class="bi bi-building"></i> Información del Remitente</div>
            <div class="card-body">
              <div class="row">
                <div class="form-group row">
                  <div class="col-md-9">
                    <label class="required" for="ruc_remitente">
                      RUC Remitente
                    </label>
                    <input v-model="form.ruc_remitente" :class="{ 'is-invalid': errors.ruc_remitente }"
                      id="ruc_remitente" @input="errors.ruc_remitente = false" class="form-control" />
                  </div>
                  <div class="col-md-3">
                    <br />
                    <a role="button" class="btn btn-primary text-white btn-sm align-items-center gap-2"
                      @click="getEmpresaRemitente()">
                      <i class="bi bi-search"></i>
                      Buscar
                    </a>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-lg-9">
                    <label class="required" for="remitente">Remitente (Cliente Inicial)</label>
                    <select v-model="form.remitente" :class="{ 'is-invalid': errors.remitente }" disabled id="remitente"
                      @change="getSucursalesRemitente()" class="form-control">
                      <option v-for="item in empresas" :key="item.id" :value="item.id">
                        {{ item.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <br />
                    <a role="button" v-if="form.remitente" class="btn btn-primary btn-sm mx-1 text-white"
                      @click="openModalDirecciones(form.remitente, sucursalesRemitente, 'remitente')">
                      <i class="bi bi-gear me-1"></i> Gestionar
                    </a>

                  </div>

                </div>
                <div class="form-group">
                  <label class="required" for="sucursal_remitente_id">
                    Seleccione Dirección del Remitente (Cliente Final)
                  </label>
                  <SelectDireccion v-model="form.sucursal_remitente_id" :options="sucursalesRemitente"
                    id="sucursal_remitente_id" :class="{ 'is-invalid': errors.sucursal_remitente_id }"
                    placeholder="Seleccione Dirección del Remitente (Cliente Final)"
                    @change="buscarDireccionRemitente()" />

                  <label class="mt-2" for="id_contacto_sucursal_origen">
                    Contacto del Remitente
                  </label>
                  <input readonly v-model="sucursalRemitente.nombre_contacto" id="id_direccion_sucursal_origen"
                    type="text" class="form-control" />
                  <label for="id_contacto_sucursal_origen">
                    Telefono de Contacto
                  </label>
                  <input readonly v-model="sucursalRemitente.telefono_contacto" id="id_direccion_sucursal_origen"
                    type="text" class="form-control" />
                  <label for="id_contacto_sucursal_origen">
                    Area de Atención
                  </label>
                  <input readonly v-model="sucursalRemitente.cargo_contacto" id="id_cargo_contacto" type="text"
                    class="form-control" />

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card bg-card mt-4">
            <div class="card-header"><i class="bi bi-geo-alt"></i> Información del Destinatario</div>
            <div class="card-body">
              <div class="row">
                <div class="form-group row">
                  <div class="col-md-9">
                    <label class="required" for="ruc_destinatario">
                      RUC Destinatario
                    </label>
                    <input v-model="form.ruc_destinatario" :class="{ 'is-invalid': errors.ruc_destinatario }"
                      id="ruc_destinatario" class="form-control" @input="errors.ruc_destinatario = false" />


                  </div>
                  <div class="col-md-3">
                    <br />
                    <a role="button" class="btn btn-primary text-white btn-sm align-items-center gap-2"
                      @click="getEmpresaDestinatario()">
                      <i class="bi bi-search"></i>
                      Buscar
                    </a>
                  </div>
                </div>
                <div class="form-group row">


                  <div class="col-lg-9">
                    <label class="required" for="destinatario">
                      Destinatario (Cliente Inicial)
                    </label>
                    <select disabled v-model="form.destinatario" :class="{ 'is-invalid': errors.destinatario }"
                      id="destinatario" @change="getSucursalesDestinatario()" class="form-control">
                      <option v-for="item in empresas" :key="item.id" :value="item.id">
                        {{ item.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <br />
                    <a role="button" v-if="form.destinatario" class="btn btn-primary btn-sm mx-1 text-white"
                      @click="openModalDirecciones(form.destinatario, sucursalesDestinatario, 'destinatario')">
                      <i class="bi bi-gear me-1"></i> Gestionar
                    </a>

                  </div>
                </div>
                <div class="form-group">
                  <label class="required" for="sucursal_destinatario_id">
                    Seleccione Dirección del Destinatario (Cliente Final)
                  </label>
                  <SelectDireccion v-model="form.sucursal_destinatario_id" :options="sucursalesDestinatario"
                    id="sucursal_destinatario_id" :class="{ 'is-invalid': errors.sucursal_destinatario_id }"
                    placeholder="Seleccione Dirección del Destinatario (Cliente Final)"
                    @change="buscarDireccionDestinatario()" />
                  <div v-if="sucursalDestinatario">

                    <label class="mt-2" for="id_contacto_sucursal_origen">
                      Contacto del Destinatario
                    </label>
                    <input readonly v-model="sucursalDestinatario.nombre_contacto" id="id_direccion_sucursal_origen"
                      type="text" class="form-control" />
                    <label for="id_contacto_sucursal_origen">
                      Telefono de Contacto
                    </label>
                    <input readonly v-model="sucursalDestinatario.telefono_contacto" id="id_direccion_sucursal_origen"
                      type="text" class="form-control" />

                    <label for="id_cargo_contacto">
                      Area de Atención
                    </label>
                    <input readonly v-model="sucursalDestinatario.cargo_contacto" id="id_cargo_contacto" type="text"
                      class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="card bg-card mt-4">
            <div class="card-header"><i class="bi bi-send"></i> Información del Envío</div>
            <div class="card-body">
              <div class="row">
                <div class="form-group col-lg-3">
                  <label class="required" for="cod_metodo_envio_id">Area Solicitante</label>
                  <select v-model="form.cod_metodo_envio_id" :disabled="form.destinatario == ''"
                    @change="getDetalleMetodoEnvio()" class="form-control" id="cod_metodo_envio_id"
                    :class="{ 'is-invalid': errors.cod_metodo_envio_id }">
                    <option v-for="item in codigosMetodoEnvio" :key="item.id" :value="item.id">
                      {{ item.codigo }}
                    </option>
                  </select>
                  <div v-if="errors.cod_metodo_envio_id" class="invalid-feedback">
                    {{ errors.cod_metodo_envio_id }}
                  </div>
                </div>

                <div class="form-group col-lg-2">
                  <label class="required" for="fecha_salida">Fecha de Salida</label>
                  <input type="date" class="form-control" :disabled="form.destinatario == ''"
                    :min="fechaSalidaMinimaAereo" v-model="form.fecha_salida" @change="buscarEnviosRelacionados()"
                    :class="{ 'is-invalid': errors.fecha_salida }" @input="errors.fecha_salida = false" />
                  <div v-if="errors.fecha_salida" class="invalid-feedback">
                    {{ errors.fecha_salida }}
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label class="required" for="horario_salida">Hora de recojo de documentos</label>
                  <input type="time" class="form-control" v-model="form.hora_recojo_documento"
                    id="hora_recojo_documento" :class="{ 'is-invalid': errors.hora_recojo_documento }"
                    @input="errors.hora_recojo_documento = false" />
                  <div v-if="errors.hora_recojo_documento" class="invalid-feedback">
                    {{ errors.hora_recojo_documento }}
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label class="required" for="horario_salida">Horario de Salida(Mercadería)</label>
                  <input type="time" class="form-control" v-model="form.horario_salida" @change="changeHoraSalida()"
                    id="horario_salida" :class="{ 'is-invalid': errors.horario_salida }"
                    @input="errors.horario_salida = false" />
                  <div v-if="errors.horario_salida" class="invalid-feedback">
                    {{ errors.horario_salida }}
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label class="required" for="id_tipo_envio">Tipo de Envío</label>
                  <select v-model="form.id_tipo_envio" class="form-control" id="id_tipo_envio"
                    :class="{ 'is-invalid': errors.id_tipo_envio }" @change="errors.id_tipo_envio = false">
                    <option v-for="item in tiposEnvio" :key="item.id" :value="item.id">
                      {{ item.nombre }}
                    </option>
                  </select>
                  <div v-if="errors.id_tipo_envio" class="invalid-feedback">
                    {{ errors.id_tipo_envio }}
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label class="required" for="id_solicitudes_envio">Solicitud de Envío</label>
                  <select v-model="form.id_solicitudes_envio" class="form-control" id="id_solicitudes_envio"
                    :class="{ 'is-invalid': errors.id_solicitudes_envio }"
                    @change="errors.id_solicitudes_envio = false">
                    <option v-for="item in solicitudesEnvio" :value="item.id_solicitudes_envio" :key="item.id">
                      {{ item.nombre }}
                    </option>
                  </select>
                  <div v-if="errors.id_solicitudes_envio" class="invalid-feedback">
                    {{ errors.id_solicitudes_envio }}
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label class="required" for="fecha_entrada">Fecha de Entrega Programada</label>
                  <input type="date" class="form-control" :value="form.fecha_entrada" disabled id="fecha_entrada"
                    :class="{ 'is-invalid': errors.fecha_entrada }" @input="errors.fecha_entrada = false" />
                  <div v-if="errors.fecha_entrada" class="invalid-feedback">
                    {{ errors.fecha_entrada }}
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label class="required" for="fecha_entrada_maxima">Fecha de Entrega Máxima</label>
                  <input type="date" class="form-control" :disabled="!form.fecha_entrada" :min="form.fecha_entrada"
                    v-model="form.fecha_entrada_maxima" id="fecha_entrada_maxima"
                    :class="{ 'is-invalid': errors.fecha_entrada_maxima }" @change="generarRangosHoras()"
                    @input="generarRangosHoras()" />
                  <div v-if="errors.fecha_entrada_maxima" class="invalid-feedback">
                    {{ errors.fecha_entrada_maxima }}
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label class="required" for="fecha_entrega">Horario de entrega máxima</label>
                  <select v-model="form.horario_entrega" class="form-control" id="horario_entrega"
                    :class="{ 'is-invalid': errors.horario_entrega }" @input="errors.horario_entrega = false">
                    <option v-for="rango in rangosHoras" :key="rango" :value="rango">
                      {{ rango }}
                    </option>
                  </select>
                  <div v-if="errors.horario_entrega" class="invalid-feedback">
                    {{ errors.horario_entrega }}
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label class="required" for="fecha_entrega">Verificación al 100%</label>
                  <select v-model="form.verificacion" name="" id="" class="form-control" @change="costoVerificacion()">
                    <option value="1">Si</option>
                    <option value="0">No</option>
                  </select>
                  <div v-if="errors.horario_entrega" class="invalid-feedback">
                    {{ errors.horario_entrega }}
                  </div>
                </div>


                <div class="form-group col-lg-12">
                  <label for="horas_extras">Observaciones</label>
                  <textarea v-model="form.observaciones" class="form-control no-resize" id="" cols="30"
                    rows="5"></textarea>
                </div>
                <div class="form-group col-lg-12" v-if="isEmergency">
                  <label for="horas_extras" class="required">Motivo de la Emergencia/Urgencia</label>
                  <textarea required v-model="form.observaciones_emergencia" class="form-control no-resize" id=""
                    cols="30" rows="5"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Secciones fuera del form -->
      <div class="row" v-if="tipoEnvio == 'exclusivo'">
        <div class="col-lg-12">
          <div class="card bg-card mt-4">
            <div class="card-header"><i class="bi bi-diagram-3"></i> Envíos Relacionados</div>
            <div class="card-body">
              <!-- Formulario para agregar -->
              <div class="row">
                <div class="form-group col-lg-2">
                  <label class="" for="fecha_entrega">
                    Envío Relacionado
                  </label>
                  <select class="form-control" v-model="form.envio_relacionado" id="envio_relacionado"
                    :class="{ 'is-invalid': errors.envio_relacionado }">
                    <option v-for="envio in enviosRelacionados" :key="envio.id" :value="envio">
                      {{ envio.rastreo }}
                    </option>
                  </select>
                  <div v-if="errors.envio_relacionado" class="invalid-feedback">
                    {{ errors.envio_relacionado }}
                  </div>
                </div>
                <div class="form-group col-md-1 d-flex align-items-end">
                  <a role="button" class="btn btn-sm btn-info d-flex align-items-center gap-2 text-white"
                    @click="changeEnvioRelacionado()">
                    <i class="bi bi-plus-circle"></i>
                  </a>
                </div>
              </div>
              <!-- Tabla con listado -->
              <div class="row mt-4">
                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="table-responsive mt-2">
                        <table class="table table-font-small">
                          <thead class="table-light">
                            <tr>
                              <th>Rastreo</th>
                              <th>RUC Remitente</th>
                              <th>Remitente(Cliente Inicial-Final)</th>
                              <th>RUC Destinatario</th>
                              <th>Destinatario(Cliente Inicial-Final)</th>
                              <th>Destino</th>
                              <th>Precio Original</th>
                              <th>Precio Del Servicio</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(envio, index) in form.enviosRelacionadosDetalle" :key="envio.id || index">
                              <td>{{ envio.rastreo }}</td>
                              <td>{{ envio.ruc_remitente }}</td>
                              <td>{{ envio.empresa_sucursal }}</td>
                              <td>{{ envio.ruc_destinatario }}</td>
                              <td>{{ envio.empresa_sucursal_destino }}</td>
                              <td>{{ envio.ubicacion_destinatario }}</td>
                              <td>{{ envio.precio_original }}</td>
                              <td>{{ envio.precio_servicio }}</td>
                              <td>
                                <a class="btn btn-sm btn-danger text-white" role="button"
                                  @click="eliminarDocumento(index)">
                                  <i class="bi bi-trash"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="card bg-card mt-4">
            <div class="card-header"><i class="bi bi-file-earmark-text"></i> Documentos del Envío</div>
            <div class="card-body">
              <!-- Formulario para agregar -->
              <div class="row">
                <div class="form-group col-lg-4">
                  <label class="required" for="detalle_metodo_envio_id">Detalle del Area Solicitante</label>
                  <select v-model="formDocumento.detalle_metodo_envio_id" class="form-control"
                    id="detalle_metodo_envio_id" :class="{ 'is-invalid': errors.detalle_metodo_envio_id }"
                    @change="errors.detalle_metodo_envio_id = false">
                    <option v-for="item in detallesMetodoEnvio" :key="item.id" :value="item.id">
                      {{ item.detalle }}
                    </option>
                  </select>
                  <div v-if="errors.detalle_metodo_envio_id" class="invalid-feedback">
                    {{ errors.detalle_metodo_envio_id }}
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label class="required" for="guia_remitente">
                    N° Guia de remisión
                  </label>
                  <input type="text" v-model="formDocumento.guia_remitente" class="form-control" id="guia_remitente" />
                </div>
                <div class="form-group col-lg-2">
                  <label for="nro_pedido">Número de Pedido</label>
                  <input type="text" class="form-control" v-model="formDocumento.nro_pedido" id="nro_pedido" />
                </div>
                <div class="form-group col-lg-2">
                  <label for="orden_compra">N° Orden de compra</label>
                  <input type="text" v-model="formDocumento.orden_compra" id="orden_compra" class="form-control" />
                </div>
                <div class="form-group col-lg-2">
                  <label for="numero_factura">N° factura</label>
                  <input type="text" v-model="formDocumento.numero_factura" id="numero_factura" class="form-control" />
                </div>
                <div class="form-group col-lg-3">
                  <label for="documentos_extras">Documentos extras</label>
                  <input type="text" v-model="formDocumento.documentos_extras" id="documentos_extras"
                    class="form-control" />
                </div>
                <div class="form-group col-md-1 d-flex align-items-end">
                  <a role="button" class="btn btn-sm btn-info d-flex align-items-center gap-2 text-white"
                    @click="agregarDocumento">
                    <i class="bi bi-plus-circle"></i>
                  </a>
                </div>
              </div>
              <!-- Tabla con listado -->
              <div class="row mt-4">
                <div class="col-lg-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="table-responsive mt-2">
                        <table class="table table-font-small">
                          <thead class="table-light">
                            <tr>
                              <th>Detalle del Area Solicitante</th>
                              <th>N° Guia de remisión</th>
                              <th>Número de Pedido</th>
                              <th>N° Orden de compra</th>
                              <th>N° factura</th>
                              <th>Documentos extras</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(doc, index) in form.documentos" :key="index">
                              <td>{{ getDetalleMetodoEnvioById(doc.detalle_metodo_envio_id) }}</td>
                              <td>{{ doc.guia_remitente }}</td>
                              <td>{{ doc.nro_pedido }}</td>
                              <td>{{ doc.orden_compra }}</td>
                              <td>{{ doc.numero_factura }}</td>
                              <td>{{ doc.documentos_extras }}</td>
                              <td>
                                <a class="btn btn-sm btn-danger text-white" role="button"
                                  @click="eliminarDocumento(index)">
                                  <i class="bi bi-trash"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card bg-card mt-4">
        <div class="card-header"><i class="bi bi-truck"></i> Selección de Vehículo</div>
        <div class="card-body">
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="origen_distrito">
                Tipo de unidad
              </label>
              <select v-model="form.tipo_unidad" id="tipo_unidad" @change="buscarUnidad()"
                class="form-control font-small">
                <option v-for="item in tipoUnidades" :key="item.id" :value="item.id">
                  {{ item.tipo_unidad }}
                </option>
              </select>
            </div>
            <div class="form-group col-lg-21" v-if="tipoEnvio == 'exclusivo'">
              <label class="required" for="cantidad_bultos">#Conductores</label>
              <select name="" id="" class="form-control" @change="buscarPrecio()" v-model="form.cant_conductor">
                <option value="1">1</option>
                <option value="2">2</option>
              </select>
            </div>

            <div class="form-group col-lg-21" v-if="tipoEnvio == 'exclusivo'">
              <label for="peso">Lead Time</label>
              <input type="text" v-model="form.lead_time_esperado" id="peso" disabled class="form-control" />
            </div>

            <div class="form-group col-lg-21" v-if="tipoEnvio == 'exclusivo'">
              <label for="peso">Precio</label>
              <input type="text" v-model="form.precio_original" id="peso" disabled class="form-control" />
            </div>
            <div class="form-group col-lg-21"
              v-if="form.enviosRelacionadosDetalle && form.enviosRelacionadosDetalle.length > 0">
              <label for="peso">Precio(40%) Relacionado</label>
              <input type="text" v-model="form.precio_servicio_relacionado" id="peso" disabled class="form-control" />
            </div>
            <div class="form-group col-lg-12">
              <span @click="showdetalleUnidad = !showdetalleUnidad" class="text-primary hover-pointer">
                Ver Detalles de la unidad
              </span>
              <br />
              <div v-if="showdetalleUnidad" class="card mt-2">
                <div class="card-body">
                  <div class="table-responsive mt-4">
                    <table class="table table-font-small">
                      <thead class="table-light">
                        <tr>
                          <th>Capacidad de peso (TN)</th>
                          <th>Capacidad de carga ( M3)</th>
                          <th>Medidas del transporte</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ parseFloat(detalleUnidad.capacidad_peso || 0).toFixed(2) }}</td>
                          <td>{{ parseFloat(detalleUnidad.capacidad_carga || 0).toFixed(2) }}</td>
                          <td>{{ detalleUnidad.medidas_transporte }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tipoEnvio == 'exclusivo'" class="card bg-card mt-4">
        <div class="card-header"><i class="bi bi-plus-square"></i> Servicios Extras</div>
        <div class="card-body">
          <div class="row mt-2">
            <div class="col-md-3">
              <label>Servicio</label>
              <select class="form-control" v-model="servicioSeleccionado" @change="cargarDatosServicio">
                <option value="">Seleccione un servicio</option>
                <option v-for="serv in serviciosExtras" :key="serv.id" :value="serv">
                  {{ serv.servicio }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label>Cantidad</label>
              <input type="number" class="form-control" v-model.number="cantidad" @input="calcularTotal" />
            </div>
            <div class="col-md-2">
              <label>Costo por Hora (S/.)</label>
              <input type="number" class="form-control" v-model="costoPorHora" disabled />
            </div>
            <div class="col-md-2">
              <label>Costo por Día (S/.)</label>
              <input type="number" class="form-control" v-model="costoPorDia" disabled />
            </div>
            <div class="col-md-2">
              <label>Total (S/.)</label>
              <input type="number" class="form-control" v-model="total" disabled />
            </div>
            <div class="col-md-1 d-flex align-items-end">
              <button type="button" class="btn btn-sm btn-warning d-flex align-items-center gap-2"
                @click="agregarServicio">
                <i class="bi bi-plus-circle"></i>
              </button>
            </div>
          </div>

          <!-- Tabla de servicios agregados -->
          <div class="mt-4">
            <div class="table-responsive text-nowrap">
              <table class="table table-font-small">
                <thead class="table-light">
                  <tr>
                    <th>Servicio</th>
                    <th>Cantidad</th>
                    <th>Costo por Hora (S/.)</th>
                    <th>Costo por Día (S/.)</th>
                    <th>Total (S/.)</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody class="table-border-bottom-0">
                  <tr v-for="(serv, index) in serviciosAgregados" :key="index">
                    <td>{{ serv.servicio }}</td>
                    <td>{{ serv.cantidad }}</td>
                    <td>{{ serv.costoPorHora }}</td>
                    <td>{{ serv.costoPorDia }}</td>
                    <td>{{ serv.total }}</td>
                    <td>
                      <button class="btn btn-danger btn-sm" @click="eliminarServicio(index)">
                        Eliminar
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-show="form.sucursal_destinatario_id" v-if="tipoEnvio == 'consolidado' || tipoEnvio == 'aereo'"
        class="card bg-card mt-4">
        <div class="card-header"><i class="bi bi-box-seam"></i> Información del Paquete</div>
        <div class="card-body">
          <div class="row my-2">
            <!-- Tipo de paquete -->
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-2">
                  <label>Nombre del Paquete</label>
                  <input type="text" class="form-control" v-model="nombrePaquete" />
                </div>
                <div class="col-md-1">
                  <label>Alto (cm)</label>
                  <input type="number" step="0.01" class="form-control" v-model.number="alto"
                    @change="calcularCosto()" />
                </div>
                <div class="col-md-1">
                  <label>Ancho (cm)</label>
                  <input type="number" step="0.01" class="form-control" v-model.number="ancho"
                    @change="calcularCosto()" />
                </div>
                <div class="col-md-1">
                  <label>Largo (cm)</label>
                  <input type="number" step="0.01" class="form-control" v-model.number="largo"
                    @change="calcularCosto()" />
                </div>
                <div class="col-md-1">
                  <label>Peso Real (kg)</label>
                  <input type="number" step="0.01" class="form-control" v-model.number="pesoReal"
                    @change="calcularCosto()" />
                </div>

                <div class="col-md-1">
                  <label>Costo kg(S/.)</label>
                  <input disabled type="number" step="0.01" class="form-control" v-model.number="costoPorKg" />
                </div>
                <div class="col-md-1">
                  <label>Peso Vol (kg)</label>
                  <input disabled type="number" step="0.01" class="form-control" v-model.number="pesoVolumetrico" />
                </div>
                <div class="col-md-1 mt-4">
                  <a role="button" class="btn btn-secondary btn-sm text-white d-flex align-items-center gap-2"
                    @click="calcularCosto">
                    <i class="bi bi-calculator"></i>
                    Calcular
                  </a>
                </div>

                <div class="col-md-2">
                  <label>Costo Paquete(S/.)</label>
                  <input disabled type="number" step="0.01" class="form-control" v-model.number="costoPaquete" />
                </div>
                <div class="col-md-1 mt-4">
                  <a role="button" class="btn btn-info btn-sm text-white d-flex align-items-center gap-2"
                    @click="agregarPaquete">
                    <i class="bi bi-plus-circle"></i>
                    Agregar
                  </a>
                </div>
                <div class="col-md-12 mt-2" v-if="costoMinimoPaquete > 0">
                  <small class="text-muted">
                    Costo minimo por paquete: S/. {{ costoMinimoPaquete.toFixed(2) }}
                    ({{ tipoEnvio === 'aereo' ? 'Aereo' : 'Terrestre' }}).
                  </small>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabla de paquetes agregados -->
          <div v-if="paquetes.length > 0" class="mt-4">
            <h5>Paquetes Agregados</h5>
            <table class="table table-font-small">
              <thead class="table-light">
                <tr>
                  <th>Nombre</th>
                  <th>Alto (cm)</th>
                  <th>Ancho (cm)</th>
                  <th>Largo (cm)</th>
                  <th>Peso (kg)</th>
                  <th>Peso volumétrico</th>
                  <th>Costo</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(paquete, index) in paquetes" :key="index">
                  <td>{{ paquete.nombre }}</td>
                  <td>{{ paquete.alto }}</td>
                  <td>{{ paquete.ancho }}</td>
                  <td>{{ paquete.largo }}</td>
                  <td>{{ paquete.peso }}</td>
                  <td>{{ paquete.pesoVolumetrico }}</td>
                  <td>{{ paquete.costo }}</td>
                  <td>
                    <button class="btn btn-danger btn-sm" @click="eliminarPaquete(index)">
                      Eliminar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mt-4">
            <hr />

            <div class="col-md-2">
              <label>Total Paquetes</label>
              <input type="number" class="form-control" v-model.number="form.cant_bultos" disabled />
            </div>
            <div class="col-md-2">
              <label>Total Peso Volumétrico (kg)</label>
              <input type="number" step="0.01" class="form-control" v-model.number="form.peso_volumen" disabled />
            </div>
            <div class="col-md-2">
              <label>Total Peso Real (kg)</label>
              <input type="number" step="0.01" class="form-control" v-model.number="form.peso_bruto" disabled />
            </div>
            <div class="col-md-2">
              <label>Costo Servicio (S/.)</label>
              <input type="number" step="0.01" class="form-control" v-model.number="costoServicio" disabled />
            </div>
            <div class="col-md-2">
              <label>Costo Verificación 100% (S/.)</label>
              <input type="number" step="0.01" class="form-control" v-model.number="costoVerificacion" disabled />
            </div>
            <div class="col-md-2">
              <label>Costo Total (S/.)</label>
              <input type="number" step="0.01" class="form-control" v-model.number="costoTotal" disabled />
            </div>
          </div>
        </div>
      </div>


      <div class="mt-3 d-flex justify-content-end mb-3">
        <button type="submit" class="btn btn-primary d-flex align-items-center gap-2"
          :disabled="tipoEnvio == 'consolidado' && !paquetes.length">
          <i class="bi bi-floppy"></i>
          Guardar
        </button>
      </div>
    </form>
    <div v-if="showModalDirecciones" class="modal fade show d-block" tabindex="-1"
      style="background: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Gestionar Direcciones</h5>
            <button type="button" class="btn-close" @click="showModalDirecciones = false"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="guardarDireccionModal">
              <div class="row">
                <div class="mb-3 col-lg-4">
                  <label class="form-label">Nombre</label>
                  <input type="text" class="form-control" v-model="direccionEdit.nombre" required />
                </div>
                <div class="mb-3 col-lg-8">
                  <label class="form-label">Dirección</label>
                  <input type="text" class="form-control" v-model="direccionEdit.direccion" required />
                </div>
                <div class="mb-3 col-lg-4">
                  <label class="form-label">Departamento</label>
                  <select class="form-control" @change="cargarProvinciasModal" v-model="direccionEdit.departamento_id"
                    required>
                    <option v-for="item in departamentos" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                  </select>
                </div>
                <div class="mb-3 col-lg-4">
                  <label class="form-label">Provincia</label>
                  <select @change="cargarDistritosModal" class="form-control" v-model="direccionEdit.provincia_id"
                    required>
                    <option v-for="item in provincias" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                  </select>
                </div>
                <div class="mb-3 col-lg-4">
                  <label class="form-label">Distrito</label>
                  <select class="form-control" v-model="direccionEdit.distrito_id" required>
                    <option v-for="item in distritos" :value="item.id" :key="item.id">{{ item.nombre }}</option>
                  </select>
                </div>
                <div class="mb-3 col-lg-4">
                  <label class="form-label">Nombre Contacto</label>
                  <input type="text" class="form-control" v-model="direccionEdit.nombre_contacto" />
                </div>
                <div class="mb-3 col-lg-3">
                  <label class="form-label">Área de atención</label>
                  <input type="text" class="form-control" v-model="direccionEdit.cargo_contacto" />
                </div>
                <div class="mb-3 col-lg-2">
                  <label class="form-label">Teléfono Contacto</label>
                  <input type="text" class="form-control" v-model="direccionEdit.telefono_contacto" />
                </div>
              </div>
              <div class="d-flex justify-content-end mb-3">
                <a @click="resetDireccion" class="btn btn-sm btn-danger text-white mx-2">
                  <i class="bi bi-x-circle me-1"></i> Cancelar
                </a>
                <button type="submit" class="btn btn-sm btn-primary">
                  <i class="bi bi-floppy me-1"></i> Guardar Dirección
                </button>
              </div>
            </form>
            <div class="table-responsive text-nowrap">
              <table class="table table-font-small mt-3">
                <thead class="table-light">
                  <tr>
                    <th>Nombre</th>
                    <th>Dirección</th>
                    <th>Departamento</th>
                    <th>Provincia</th>
                    <th>Distrito</th>
                    <th>Contacto</th>
                    <th>Área de atención</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="direccion in sucursalesData" :key="direccion.id">
                    <td>{{ direccion.nombre }}</td>
                    <td>{{ direccion.direccion }}</td>
                    <td>{{ direccion.departamento_nombre }}</td>
                    <td>{{ direccion.provincia_nombre }}</td>
                    <td>{{ direccion.distrito_nombre }}</td>
                    <td>{{ direccion.nombre_contacto }} {{ direccion.telefono_contacto }}</td>
                    <td>{{ direccion.cargo_contacto }}</td>
                    <td>
                      <button class="btn btn-warning btn-sm me-2" @click="editarDireccion(direccion)">
                        <i class="bi bi-pencil-square"></i>
                      </button>
                      <button class="btn btn-danger btn-sm" @click="eliminarDireccion(direccion.id)">
                        <i class="bi bi-trash3-fill"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import router from '@/router' // Asegúrate de importar tu instan
import SelectDireccion from '@/components/SelectDireccion.vue'


export default {
  name: 'ShippingPage',
  components: { SelectDireccion },
  data() {
    return {
      isLoading: false,
      fechaSalidaMinimaAereo: '',
      isEmergency: false,
      tipoEmpresa: "",
      enviosRelacionados: [],
      envioId: this.$route.params.id,
      editandoDireccion: false,
      tipoEnvio: this.$route.params.tipo_envio,
      tipoEnvioLabel: '',
      rangosHoras: [],
      showModalDirecciones: false,
      errors: {},
      pedidoResponse: {},
      departamentos: [],
      provincias: [],
      distritos: [],
      sucursalesData: [],
      formDocumento: {
        detalle_metodo_envio_id: '',
        guia_remitente: '',
        nro_pedido: '',
        orden_compra: '',
        numero_factura: '',
        documentos_extras: ''
      },
      direccionEdit: {
        empresa_id: null,
        nombre: '',
        direccion: '',
        distrito_id: null,
        nombre_contacto: '',
        cargo_contacto: '',
        telefono_contacto: '',
        email_contacto: '',
      },
      form: {
        envio_relacionado: {},
        ruc_remitente: '',
        remitente: '',
        ruc_destinatario: '',
        destinatario: '',
        hora_recojo_documento: '',
        sucursal_remitente_id: '',
        sucursal_destinatario_id: '',
        fecha_salida: null,
        horario_recojo: "",
        fecha_entrada: '',
        dias_entrega: '',
        horas_extra: '',
        cod_metodo_envio_id: '',
        documentos: [],
        paquetes: [],
        enviosRelacionadosDetalle: [],
        documentos_extras: '',
        cant_bultos: '',
        cant_conductor: '1',
        precio_servicio: '',
        precio_original: '',
        peso_bruto: '',
        peso_volumen: '',
        tipo_unidad: '1',
        medidas: '',
        flete: '',
        falso_flete_provincia: '',
        flete_cancelacion: '',
        flete_visita_extra: '',
        flete_hora_extra: '',
        flete_local_urgencia: '',
        gastos_admin: '',
        gastos_total: '',
        detalle_gastos_admin: '',
        id_causa_visita: '',
        detalle_causa_visita: '',
        detalle_mercaderia: '',
        id_modalidades_envio: '3',
        id_tipo_envio: '',
        id_solicitudes_envio: '',
        detalle_solicitud_envio: '',
        id_estados_envio: '1',
        id_causa_entrega: '',
        detalle_causa_entrega: '',
        lead_time_esperado: '',
        cumplimiento_lead_time: '',
        causa_cumplimiento_lead_time: '',
        detalle_cumplimiento_lead_time: '',
        lead_time_cargos: '',
        causa_cumplimiento_lead_time_cargos: '',
        estado_retorno_cargos: '',
        lead_time_retorno_doc: '',
        cumplimiento_lead_time_retorno: '',
        causa_cumplimiento_lead_time_retorno: '',
        conformidad: '',
        conformidad_draeger: 'SIN RECEPCIONAR',
        observaciones: '',
        solicitante: '',
        horario_salida: null,
        horario_entrega: '',
        tipo_paquete: 'mercaderia',
        precio_servicio_relacionado: 0,
        verificacion: 0,
        es_recojo: 0,
        observaciones_emergencia: '',
        max: ''
      },
      codigosMetodoEnvio: [],
      detallesMetodoEnvio: [],
      tiposEnvio: [],
      empresas: [],
      tipoUnidades: [],
      sucursalesRemitente: [],
      sucursalRemitente: {},
      sucursalesDestinatario: [],
      detalleUnidad: '',
      showdetalleUnidad: false,
      sucursalDestinatario: {},
      serviciosExtras: [],

      // Variables del formulario
      servicioSeleccionado: '',
      cantidad: 1,
      costoPorHora: 0,
      costoPorDia: 0,
      total: 0,
      // Lista de servicios agregados
      serviciosAgregados: [],
      solicitudesEnvio: [],
      nombrePaquete: '',
      alto: 0,
      largo: 0,
      ancho: 0,
      pesoReal: 0,
      pesoVolumetrico: 0,
      costoPorKg: 0,
      costoPaquete: 0,
      paquetes: [],
      tipo_costo: 'peso_volumen',
    }
  },

  async mounted() {
    this.isLoading = true;
    const user = JSON.parse(localStorage.getItem('user'))
    if (user) this.form.solicitante = `${user.name} ${user.apellido}`
    try {
      this.validarFechaSalida()
      await this.getCodigoMetodoEnvio()
      await this.getEmpresas()
      await this.getTipoUnidades()
      await this.buscarUnidad()
      await this.getServiciosExtras()
      this.cargarDepartamentos();
      if (this.envioId) {
        await this.getEnvio();
        await this.getDetalleMetodoEnvio();
        await this.getSolicitudesEnvio();
        await this.generarRangosHoras();
        await this.buscarEnviosRelacionados();
      }
      await this.getSucursalesRemitente()
      await this.getSucursalesDestinatario()
      await this.buscarDireccionRemitente()
    }
    catch (error) {
      console.error('Error al cargar los datos del envío:', error);
      this.isLoading = false;
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    totalPaquetes() {
      return this.paquetes.length
    },
    totalPesoVolumetrico() {
      return this.paquetes.reduce((total, p) => total + (parseFloat(p.pesoVolumetrico) || 0), 0)
    },
    totalPesoReal() {
      return this.paquetes.reduce((total, p) => total + (parseFloat(p.peso) || 0), 0)
    },
    costoServicio() {
      return this.paquetes.reduce((total, p) => total + (parseFloat(p.costo) || 0), 0);
    },

    costoVerificacion() {
      if (this.form.verificacion == "1") {
        return 200;
      } return 0;
    },

    costoTotal() {
      const servicio = Number(this.costoServicio) || 0;
      const verificacion = Number(this.costoVerificacion) || 0;

      console.log("servicio", servicio)
      console.log("verificacion", verificacion)
      return Number((servicio + verificacion).toFixed(2));
    },

    costoMinimoPaquete() {
      if (this.tipoEnvio === 'aereo') {
        return 203.02;
      }
      if (this.tipoEnvio === 'consolidado') {
        return 101.51;
      }
      return 0;
    }

  },
  watch: {
    form: {
      handler(newForm) {
        if (newForm.destinatario) {
          this.errors.destinatario = false
        }
        if (newForm.sucursal_destinatario_id) {
          this.errors.sucursal_destinatario_id = false
        }
        if (newForm.remitente) {
          this.errors.remitente = false
        }
        if (newForm.sucursal_remitente_id) {
          this.errors.sucursal_remitente_id = false
        }
      },
      deep: true, // Permite observar cambios en propiedades internas de `form`
    },
    '$route.params.tipo_envio'(nuevoValor) {
      this.tipoEnvio = nuevoValor
      this.validarFechaSalida()
      this.changeHoraSalida()
      this.getTipoEnvio()

    },
    paquetes: {
      handler(newVal) {
        this.form.cant_bultos = newVal.length
        this.form.peso_volumen = newVal.reduce(
          (total, p) => total + (parseFloat(p.pesoVolumetrico) || 0),
          0,
        )
        this.form.peso_bruto = newVal.reduce((total, p) => total + (parseFloat(p.peso) || 0), 0)
      },
      deep: true,
    },
  },
  methods: {
    // onUpdateForm eliminado, ya no es necesario con v-model
    validarFechaSalida() {
      if (this.tipoEnvio == "aereo" || this.tipoEnvio == "consolidado") {
        const ahora = new Date();
        let fechaMin = new Date();

        if (ahora.getHours() >= 15) {
          fechaMin.setDate(fechaMin.getDate() + 1);
        }
        const yyyy = fechaMin.getFullYear();
        const mm = String(fechaMin.getMonth() + 1).padStart(2, '0');
        const dd = String(fechaMin.getDate()).padStart(2, '0');

        this.fechaSalidaMinimaAereo = `${yyyy}-${mm}-${dd}`;
      } else {
        this.fechaSalidaMinimaAereo = ""
      }
    },
    changeHoraSalida() {
      if (this.form.horario_salida != "") {
        const [horaStr, minStr] = this.form.horario_salida.split(':');

        let horaMAxima = 24
        let horaMAximaString = ""
        if (this.tipoEnvio == "aereo") {
          horaMAxima = 16
          horaMAximaString = "4:00 p.m"
        } else if (this.tipoEnvio == "consolidado") {
          horaMAxima = 15
          horaMAximaString = "3:00 p.m"
        }

        if (parseInt(horaStr) > horaMAxima || (parseInt(horaStr) == horaMAxima && parseInt(minStr) >= 1)) {
          this.form.horario_salida = ""
          Swal.fire("Advertencia", "la hora de Salida, no puede ser mayor de las " + horaMAximaString);
          return;
        } else {
          this.getTipoEnvio()
          this.getSolicitudesEnvio()
        }
      }
    },
    getDetalleMetodoEnvioById(detalle_metodo_envio_id) {

      if (this.detallesMetodoEnvio.length > 0) {
        const item = this.detallesMetodoEnvio.find(item => item.id == detalle_metodo_envio_id);
        return item ? item.detalle : '';
      } else {
        return '';
      }

    },
    async cargarDepartamentos() {
      try {
        this.provincias = [];
        const response = await axios.get('/departamentos')
        this.departamentos = response.data
      } catch (error) {
        console.error('Error al cargar departamentos', error)
      }
    },
    async cargarProvincias() {
      try {
        this.distritos = []
        const response = await axios.get('/provinciasByDepartamentos/' + this.direccionEdit.departamento_id)
        this.provincias = response.data
      } catch (error) {
        console.error('Error al cargar provincias', error)
      }
    },
    async cargarDistritos() {
      try {
        const response = await axios.get('/distritosByProvincias/' + this.direccionEdit.provincia_id)
        this.distritos = response.data
      } catch (error) {
        console.error('Error al cargar distritos', error)
      }
    },
    async buscarEnviosRelacionados() {
      await this.getSolicitudesEnvio()
      this.calcularFechaEntrega();
      this.form.enviosRelacionadosDetalle = []
      try {
        const { data } = await axios.get('envios-relacionados?fecha=' + this.form.fecha_salida)
        this.enviosRelacionados = data
      } catch (error) {
        console.error('Error al buscar envíos', error)
      }
    },
    async getEnvio() {
      try {
        const response = await axios.get('envios/' + this.envioId)
        this.form = response.data
        this.paquetes = response.data.paquetes ?? []
        console.log("this.paquetes", response.data.paquetes)
        this.tipoEnvio = response.data.modalidades_envio.toLowerCase()
      } catch (error) {
        console.error('Error cargando detalles de envío:', error)
      }
    },

    generarRangosHoras() {
      let rangos = []
      let tipoEnvio = this.$route.params.tipo_envio
      const incremental = tipoEnvio === 'exclusivo' ? 1 : 1

      if (!tipoEnvio) { tipoEnvio = this.tipoEnvio }

      const fechaProgramada = this.form.fecha_entrada
      const fechaMaxima = this.form.fecha_entrada_maxima

      if (!fechaProgramada || !fechaMaxima) return []

      if (fechaMaxima === fechaProgramada) {
        // Solo horas sueltas: 3PM a 6PM
        if (tipoEnvio === 'exclusivo') {
          const horaInicio = tipoEnvio === 'exclusivo' ? 8 : 9
          for (let i = horaInicio; i < 18; i += incremental) {
            let inicio = this.formatearHora(i)
            let fin = this.formatearHora(i + incremental)
            if (i + incremental <= 18) { // para evitar pasarse de las 6pm
              rangos.push(`${inicio} - ${fin}`)
            }
          }
        } else {
          for (let hora = 15; hora <= 18; hora++) {
            rangos.push(this.formatearHora(hora))
          }
        }
      } else if (fechaMaxima > fechaProgramada) {
        const horaInicio = tipoEnvio === 'exclusivo' ? 8 : 9
        for (let i = horaInicio; i < 18; i += incremental) {
          let inicio = this.formatearHora(i)
          let fin = this.formatearHora(i + incremental)
          if (i + incremental <= 18) { // para evitar pasarse de las 6pm
            rangos.push(`${inicio} - ${fin}`)
          }
        }
      }

      this.rangosHoras = rangos
      return rangos
    },

    formatearHora(hora) {
      let sufijo = hora < 12 ? 'AM' : 'PM'
      let hora12 = hora <= 12 ? hora : hora - 12
      return `${hora12}:00 ${sufijo}`
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('es-PE', {
        style: 'currency',
        currency: 'PEN',
        minimumFractionDigits: 0,
      }).format(value)
    },
    async getCodigoMetodoEnvio() {
      try {
        const response = await axios.get('cod-metodo-envio')
        this.codigosMetodoEnvio = response.data // Usar response.data
      } catch (error) {
        console.error('Error cargando códigos de método de envío:', error)
      }
    },

    async getDetalleMetodoEnvio() {
      if (this.form.cod_metodo_envio_id) {
        this.errors.cod_metodo_envio_id = false // Se elimina el error cuando se selecciona un valor válido
      }
      try {
        const response = await axios.get(
          'detalle-envio-by-codigo/' + this.form.cod_metodo_envio_id + "?es_documento=false",
        )
        this.detallesMetodoEnvio = response.data // Usar response.data
      } catch (error) {
        console.error('Error cargando detalles de método de envío:', error)
      }
    },
    changeEnvioRelacionado() {
      if (this.form.envio_relacionado && Object.keys(this.form.envio_relacionado).length > 0) {
        const nuevoArray = [...this.form.enviosRelacionadosDetalle, this.form.envio_relacionado]
        this.$set(this.form, 'enviosRelacionadosDetalle', nuevoArray)
        // Limpiar el select después de agregar
        this.form.envio_relacionado = {}
        this.buscarPrecio();
      }
    },
    crearFechaLocal(fechaStr) {
      const partes = fechaStr.split('-'); // ["2025", "06", "02"]
      const anio = parseInt(partes[0], 10);
      const mes = parseInt(partes[1], 10) - 1; // meses en JS van 0 a 11
      const dia = parseInt(partes[2], 10);
      return new Date(anio, mes, dia); // crea fecha en zona local, hora 00:00
    },

    async getSolicitudesEnvio() {
      const ahora = new Date();

      function crearFechaLocal(fechaStr) {
        const partes = fechaStr.split('-');
        const anio = parseInt(partes[0], 10);
        const mes = parseInt(partes[1], 10) - 1;
        const dia = parseInt(partes[2], 10);
        return new Date(anio, mes, dia);
      }

      const inicioVentana = new Date();
      inicioVentana.setHours(13, 0, 0, 0);

      const finVentana = new Date(inicioVentana);
      finVentana.setDate(finVentana.getDate() + 1);

      const fechaSalida = crearFechaLocal(this.form?.fecha_salida);

      const inicioDiaActual = new Date();
      inicioDiaActual.setHours(0, 0, 0, 0);

      const esFechaSalidaValida = fechaSalida.getTime() === inicioDiaActual.getTime();

      const enVentana = ahora >= inicioVentana && ahora < finVentana;

      const todas = [
        { id_solicitudes_envio: 2, nombre: "URGENCIA", created_at: "2025-02-21T20:49:37.000000Z" },
        { id_solicitudes_envio: 3, nombre: "EMERGENCIA", created_at: "2025-02-21T20:49:37.000000Z" },
        { id_solicitudes_envio: 1, nombre: "NORMAL", created_at: "2025-02-21T20:49:37.000000Z" }
      ];

      if (enVentana && esFechaSalidaValida) {
        this.isEmergency = true
        this.solicitudesEnvio = todas.filter(s =>
          s.nombre === 'URGENCIA' || s.nombre === 'EMERGENCIA'
        );
      } else {
        this.isEmergency = false
        this.solicitudesEnvio = todas.filter(s =>
          s.nombre === 'NORMAL'
        );
      }
      this.getTipoEnvio()
      // Debug
      console.log("ahora:", ahora);
      console.log("inicioVentana:", inicioVentana);
      console.log("finVentana:", finVentana);
      console.log("fechaSalida:", fechaSalida);
      console.log("inicioDiaActual:", inicioDiaActual);
      console.log("enVentana:", enVentana);
      console.log("esFechaSalidaValida:", esFechaSalidaValida);

      this.form.id_solicitudes_envio = 1;
    },

    async getServiciosExtras() {
      try {
        const response = await axios.get('servicios-extras')
        this.serviciosExtras = response.data // Usar response.data
      } catch (error) {
        console.error('Error cargandoservicios Extras:', error)
      }
    },

    async getTipoEnvio() {
      if (this.form.horario_salida == null || this.form.fecha_salida == null) { return; }
      try {
        const ids = this.calcularIdsTipoEnvio();
        const response = await axios.get('tipos-envio', { params: { ids } });

        this.tiposEnvio = response.data;
        this.form.id_tipo_envio = ids[0];
      } catch (error) {
        console.error('Error cargando tipos de envío:', error);
      }
    },

    calcularIdsTipoEnvio() {
      const tipo = this.tipoEnvio;
      const form = this.form;

      if (['exclusivo', 'consolidado'].includes(tipo)) {
        return [5];
      }

      if (tipo === 'aereo') {

        const esHoy = this.esFechaHoyOManana(form.fecha_salida);
        const horaActual = new Date().getHours();
        const salidaTarde = this.salidaEsDespuesDeHora(form.horario_salida, 15);

        if (esHoy && (horaActual >= 13 && salidaTarde)) {
          return [1]; // Prime
        }

        return [3]; // Aéreo normal
      }

      return []; // Tipo desconocido
    },

    esFechaHoyOManana(fechaString) {
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);

      const mañana = new Date(hoy);
      mañana.setDate(hoy.getDate() + 1); // Suma un día
      mañana.setHours(0, 0, 0, 0);

      const [year, month, day] = fechaString.split('-');
      const fecha = new Date(+year, +month - 1, +day);
      fecha.setHours(0, 0, 0, 0);

      return (
        fecha.getTime() === hoy.getTime() ||
        fecha.getTime() === mañana.getTime()
      );
    },


    salidaEsDespuesDeHora(horario, horaLimite) {
      if (!horario) return false;

      const [horaStr, minStr] = horario.split(':');
      const hora = parseInt(horaStr);
      const minutos = parseInt(minStr);

      return hora > horaLimite || (hora === horaLimite && minutos > 0);
    },


    async getTipoUnidades() {
      try {
        let ids = [1, 2, 3, 4, 5, 6, 7];
        const params = ids.length ? { ids: ids.join(',') } : {} // Convertir array a string si hay IDs
        const response = await axios.get('tipo-unidades', { params })
        this.tipoUnidades = response.data.sort((a, b) => a.tipo_unidad.localeCompare(b.tipo_unidad))
      } catch (error) {
        console.error('Error cargando tipoUnidades:', error)
      }
    },

    buscarUnidad() {
      this.detalleUnidad = this.tipoUnidades.find(
        (item) => item.id == this.form.tipo_unidad,
      )
      this.buscarPrecio()
    },
    buscarDireccionRemitente() {

      if (this.form.sucursal_remitente_id) {
        this.errors.sucursal_remitente_id = false
        this.sucursalRemitente = this.sucursalesRemitente.find(
          (item) => item.id == this.form.sucursal_remitente_id,
        )
      }

    },
    calcularFechaEntrega() {
      const horas = parseInt(this.form.lead_time_esperado);
      const fechaSalida = new Date(this.form.fecha_salida);
      const fechaEntrega = new Date(fechaSalida.getTime() + horas * 60 * 60 * 1000);
      console.log("fechaEntrega", fechaEntrega)
      this.form.fecha_entrada = fechaEntrega.toISOString().split('T')[0];
    },
    buscarDireccionDestinatario() {
      this.sucursalDestinatario = this.sucursalesDestinatario.find(
        (item) => item.id == this.form.sucursal_destinatario_id,
      )
      this.buscarPrecio()
    },
    async buscarPrecio() {
      try {
        if (!this.sucursalDestinatario.distrito_id) {
          this.limpiarPrecios()
          return
        }

        let url = ''
        let distrito_id = 0;

        if (this.form.es_recojo == 1) {
          distrito_id = this.sucursalRemitente.distrito_id;
        } else {
          distrito_id = this.sucursalDestinatario.distrito_id;
        }

        if (this.tipoEnvio === 'exclusivo') {
          url = `precio-exclusivo/${this.form.tipo_unidad}/${distrito_id}/${this.form.cant_conductor}`
        } else {
          url = `precio-consolidado/${this.tipo_costo}/${this.sucursalDestinatario.distrito_id}`
        }

        const response = await axios.get(url)
        const data = response.data
        this.form.lead_time_esperado = data.lead_time

        console.log("data!!", data)

        if (this.form.fecha_salida) {
          this.calcularFechaEntrega();
        }
        console.log("this.tipoEnvio", this.tipoEnvio)
        if (this.tipoEnvio === 'exclusivo') {
          let precio = parseFloat(data.precio_servicio) || 0;

          if (this.form.es_recojo == 1) {
            precio = parseFloat((precio * 1.4).toFixed(2));
          }

          this.form.precio_servicio = precio;
          this.form.precio_original = precio;



          const relacionados = this.form.enviosRelacionadosDetalle || [];

          if (relacionados.length > 0) {
            const mayorPrecioRelacionado = Math.max(
              ...relacionados.map(envio => parseFloat(envio.precio_original) || 0)
            );
            console.log("mayorPrecioRelacionado", mayorPrecioRelacionado)
            const precioRelacionado = precio <= mayorPrecioRelacionado ? precio * 0.4 : precio;

            this.$set(this.form, 'precio_servicio_relacionado', parseFloat(precioRelacionado.toFixed(2)));
            this.form.precio_servicio = precioRelacionado;
            console.log("this.form.precio_servicio_relacionado", this.form.precio_servicio_relacionado)
          } else {
            // Si no hay relacionados, limpiar el valor
            this.$set(this.form, 'precio_servicio_relacionado', 0);
          }

        } else {
          this.costoPorKg = data.costo;
        }

      } catch (error) {
        console.error(`Error al cargar precios (${this.tipoEnvio}):`, error)

        if (error.response && error.response.status === 404) {
          if (this.tipoEnvio === 'aereo') {
            Swal.fire({
              icon: 'warning',
              title: 'Sin cobertura',
              text: 'Lo sentimos, no hay cobertura para el destino seleccionado.',
              confirmButtonText: 'Aceptar'
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Aún sin tarifario definido',
              text: 'Comunicarse con el proveedor.',
            });
          }
        } else {
          if (this.tipoEnvio === 'aereo') {
            Swal.fire({
              icon: 'warning',
              title: 'Sin cobertura',
              text: 'Lo sentimos, no hay cobertura para el destino seleccionado.',
              confirmButtonText: 'Aceptar'
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Aún sin tarifario definido',
              text: 'Comunicarse con el proveedor.',
            });
          }
        }

        this.limpiarPrecios()
      }
    },

    limpiarPrecios() {
      this.form.lead_time_esperado = ''
      this.form.falso_flete_provincia = 0
      this.form.precio_servicio = 0
    },

    openModalDirecciones(empresa_id, data, tipo) {
      this.tipoEmpresa = tipo
      this.sucursalesData = data;
      this.direccionEdit.empresa_id = empresa_id;
      this.showModalDirecciones = true;
    },

    resetDireccion() {
      this.direccionEdit = {
        empresa_id: this.direccionEdit.empresa_id, // se conserva: el modal sigue siendo de la misma empresa
        nombre: '',
        direccion: '',
        distrito_id: null,
        nombre_contacto: '',
        cargo_contacto: '',
        telefono_contacto: '',
        email_contacto: '',
      };
    },
    agregarDocumento() {
      if (!this.formDocumento.guia_remitente) {
        Swal.fire('Atención', 'Debe ingresar al menos la guía de remisión', 'warning');
        return;
      }
      if (!this.formDocumento.detalle_metodo_envio_id) {
        Swal.fire('Atención', 'Debe ingresar el Detalle del metodo de envío', 'warning');
        return;
      }
      this.form.documentos.push({ ...this.formDocumento });
      this.formDocumento = {
        detalle_metodo_envio_id: '',
        guia_remitente: '',
        nro_pedido: '',
        orden_compra: '',
        numero_factura: '',
        documentos_extras: ''
      };
    },
    eliminarDocumento(index) {
      this.form.documentos.splice(index, 1);
    },
    agregarPaquete() {
      if (!this.nombrePaquete || !this.alto || !this.ancho || !this.largo || !this.pesoReal) {
        Swal.fire('Atención', 'Completa todos los campos antes de agregar el paquete.', 'warning');
        return;
      }
      this.paquetes.push({
        nombre: this.nombrePaquete,
        alto: this.alto,
        ancho: this.ancho,
        largo: this.largo,
        peso: this.pesoReal,
        pesoVolumetrico: this.pesoVolumetrico,
        costo: this.costoPaquete,
      });
      // Limpiar los campos
      this.nombrePaquete = '';
      this.alto = '';
      this.ancho = '';
      this.largo = '';
      this.pesoReal = '';
      this.pesoVolumetrico = 0;
      this.costoPaquete = 0;
    },
    eliminarPaquete(index) {
      this.paquetes.splice(index, 1)
    },

    calcularCosto() {
      // Validación básica para evitar NaN
      const alto = parseFloat(this.alto) || 0;
      const ancho = parseFloat(this.ancho) || 0;
      const largo = parseFloat(this.largo) || 0;
      const pesoReal = parseFloat(this.pesoReal) || 0;
      this.pesoVolumetrico = (alto * ancho * largo) / 5000;
      let mayorPeso = Math.max(pesoReal, this.pesoVolumetrico);
      const costoCalculado = mayorPeso * (parseFloat(this.costoPorKg) || 0);
      const costoFinal = Math.max(costoCalculado, this.costoMinimoPaquete);
      this.costoPaquete = parseFloat(costoFinal.toFixed(2));
    },
    cargarDatosServicio() {
      if (this.servicioSeleccionado) {
        this.costoPorHora = this.servicioSeleccionado.costo_por_hora
        this.costoPorDia = this.servicioSeleccionado.costo_por_dia
        this.calcularTotal()
      }
    },
    // Calcular el total basado en cantidad
    calcularTotal() {
      if (this.servicioSeleccionado) {
        if (this.costoPorHora > 0) {
          this.total = (this.costoPorHora * this.cantidad).toFixed(2)
        } else {
          this.total = (this.costoPorDia * this.cantidad).toFixed(2)
        }
      }
    },

    async getEmpresas() {
      try {
        const response = await axios.get('empresas')
        this.empresas = response.data // Usar response.data
      } catch (error) {
        console.error('Error cargando empresas:', error)
      }
    },
    async getSucursalesRemitente(actualizarDatos) {
      try {
        const response = await axios.get(
          'empresa-sucursales/' + this.form.remitente,
        )
        this.sucursalesRemitente = await response.data // Usar response.data             
        this.buscarDireccionRemitente()
        if (actualizarDatos) {
          this.sucursalesData = await response.data
        }
      } catch (error) {
        console.error('Error cargando sucursales:', error)
      }
    },

    async getEmpresaRemitente() {
      try {
        const response = await axios.get(
          'empresa-by-ruc/' + this.form.ruc_remitente,
        )

        const empresa = response.data

        if (empresa && empresa.id) {
          this.form.remitente = empresa.id
          this.getSucursalesRemitente()

        } else {
          this.form.remitente = null
          Swal.fire({
            icon: 'warning',
            title: 'Empresa no encontrada',
            text: 'No se encontró una empresa con ese RUC.',
          })
        }
      } catch (error) {
        console.error('Error buscando empresa:', error)

        if (error.response && error.response.status === 404) {
          Swal.fire({
            icon: 'warning',
            title: error.response.data.error || 'Empresa no encontrada',
            text: error.response.data.message || 'No se encontró una empresa con ese RUC.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error de conexión',
            text: 'Ocurrió un error al consultar la empresa. Intenta nuevamente.',
          })
        }
      }
    },


    async getEmpresaDestinatario() {
      try {
        const response = await axios.get(
          'empresa-by-ruc/' + this.form.ruc_destinatario,
        )

        const empresa = response.data

        if (empresa && empresa.id) {
          // Si es el mismo destinatario, igual se recarga la lista (pueden haber
          // agregado sucursales), pero se conserva el precio ya calculado.
          const esElMismoDestinatario = this.form.destinatario === empresa.id

          this.form.destinatario = empresa.id
          this.getSucursalesDestinatario(false, esElMismoDestinatario)
        } else {
          this.form.destinatario = null
          Swal.fire({
            icon: 'warning',
            title: 'Empresa no encontrada',
            text: 'No se encontró una empresa con ese RUC.',
          })
        }
      } catch (error) {
        console.error('Error cargando empresas:', error)

        if (error.response && error.response.status === 404) {
          Swal.fire({
            icon: 'warning',
            title: error.response.data.error || 'Empresa no encontrada',
            text: error.response.data.message || 'No existe ninguna empresa registrada con ese RUC.',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error de conexión',
            text: 'Ocurrió un error al consultar la empresa destinataria.',
          })
        }
      }
    },
    // conservarDatos: recarga la lista de sucursales sin perder el precio
    // calculado (se usa al volver a buscar el mismo RUC).
    async getSucursalesDestinatario(actualizarDatos, conservarDatos = false) {
      if (!conservarDatos) {
        this.limpiarPrecios()
      }
      try {
        const response = await axios.get(
          'empresa-sucursales/' + this.form.destinatario,
        )
        this.sucursalesDestinatario = await response.data
        if (actualizarDatos) {
          this.sucursalesData = await response.data
        }
        // En edición no se dispara el @change del select, así que forzamos la carga de precio.
        if (this.envioId && this.form.sucursal_destinatario_id) {
          this.sucursalDestinatario = this.sucursalesDestinatario.find(
            (item) => item.id == this.form.sucursal_destinatario_id,
          ) || {}

          if (this.sucursalDestinatario.distrito_id) {
            this.buscarPrecio()
          }
        }

      } catch (error) {
        console.error('Error cargando sucursales:', error)
      }
    },

    async editarDireccion(direccion) {
      this.direccionEdit = { ...direccion };
      this.editandoDireccion = true;
      this.editId = direccion.id;
      await this.cargarProvincias()
      await this.cargarDistritos()
    },
    async eliminarDireccion(id) {
      try {
        await axios.delete(`sucursales/${id}`);
        this.getSucursalesDestinatario();
      } catch (error) {
        console.error('Error al eliminar dirección:', error);
      }
    },
    async guardarDireccion() {
      try {
        if (this.editandoDireccion) {
          await axios.put(`sucursales/${this.editId}`, this.direccionEdit);
        } else {
          await axios.post('sucursales', this.direccionEdit);
        }
        this.resetDireccion();  // Reset form
        if (this.tipoEmpresa == "remitente") {
          await this.getSucursalesRemitente(true);
        } else {
          await this.getSucursalesDestinatario(true);
        }

      } catch (error) {
        console.error('Error al guardar dirección:', error);
      }
    },
    guardarDireccionModal() {
      const self = this;
      (async function () {
        try {
          if (self.editandoDireccion) {
            await self.$options.methods.guardarDireccion.call(self);
          } else {
            await self.$options.methods.guardarDireccion.call(self);
          }
          Swal.fire({
            icon: 'success',
            title: 'Dirección agregada',
            text: 'La dirección se ha guardado correctamente.'
          });
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo guardar la dirección.'
          });
        }
      })();
    },
    cargarProvinciasModal() {
      this.cargarProvincias();
    },
    cargarDistritosModal() {
      this.cargarDistritos();
    },


    // Agregar el servicio a la tabla
    agregarServicio() {
      if (!this.servicioSeleccionado || this.cantidad <= 0) {
        Swal.fire('Atención', 'Seleccione un servicio y una cantidad válida.', 'warning');
        return;
      }
      this.serviciosAgregados.push({
        servicio: this.servicioSeleccionado.servicio,
        cantidad: this.cantidad,
        costoPorHora: this.costoPorHora,
        costoPorDia: this.costoPorDia,
        total: this.total,
      });
      // Reiniciar los campos
      this.servicioSeleccionado = '';
      this.cantidad = 1;
      this.costoPorHora = 0;
      this.costoPorDia = 0;
      this.total = 0;
    },
    // Eliminar un servicio de la tabla
    eliminarServicio(index) {
      this.serviciosAgregados.splice(index, 1)
    },
    validateForm() {
      this.errors = {}

      if (!this.form.documentos || this.form.documentos.length === 0) {
        Swal.fire('Atención', 'Debe agregar al menos un documento al envío.', 'warning');
        return false;
      }

      if (!this.form.cod_metodo_envio_id) {
        this.errors.cod_metodo_envio_id = 'Campo obligatorio'
      }

      if (!this.form.id_tipo_envio) {
        this.errors.id_tipo_envio = 'Campo obligatorio'
      }
      if (!this.form.id_solicitudes_envio) {
        this.errors.id_solicitudes_envio = 'Campo obligatorio'
      }
      if (!this.form.fecha_salida) {
        this.errors.fecha_salida = 'Campo obligatorio'
      }
      if (!this.form.horario_salida) {
        this.errors.horario_salida = 'Campo obligatorio'
      }
      if (!this.form.fecha_entrada) {
        this.errors.fecha_entrada = 'Campo obligatorio'
      }
      if (!this.form.horario_entrega) {
        this.errors.horario_entrega = 'Campo obligatorio'
      }
      if (!this.form.ruc_remitente) {
        this.errors.ruc_remitente = 'Campo obligatorio'
      }
      if (!this.form.remitente) {
        this.errors.remitente = 'Campo obligatorio'
      }
      if (!this.form.sucursal_remitente_id) {
        this.errors.sucursal_remitente_id = 'Campo obligatorio'
      }
      if (!this.form.ruc_destinatario) {
        this.errors.ruc_destinatario = 'Campo obligatorio'
      }
      if (!this.form.destinatario) {
        this.errors.destinatario = 'Campo obligatorio'
      }
      if (!this.form.sucursal_destinatario_id) {
        this.errors.sucursal_destinatario_id = 'Campo obligatorio'
      }
      return Object.keys(this.errors).length === 0
    },

    async submitForm() {
      if (!this.validateForm()) {
        return
      }

      const ahora = new Date()
      const hora = ahora.getHours()

      const confirmacion = await Swal.fire({
        title: '¿Confirma el envío? Tiene hasta 45 minutos para cancelarlo antes de que se procese el cobro.',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, enviar',
        cancelButtonText: 'Cancelar',
      })

      if (!confirmacion.isConfirmed) {
        return
      }
      if (this.tipoEnvio == 'aereo') {
        const esHoy = this.esFechaHoyOManana(this.form.fecha_salida);
        if (esHoy && hora >= 16) {
          // Si es después de la 1 PM
          const result = await Swal.fire({
            title: 'Advertencia',
            text:
              'Estás guardando fuera del horario de corte, vas a aplicar a una tarifa prime ¿Deseas continuar?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, guardar',
            cancelButtonText: 'Cancelar',
          })

          if (!result.isConfirmed) {
            return // Si cancela, no hace nada
          }
        }
      }

      try {
        let response
        switch (this.tipoEnvio) {
          case 'exclusivo':
            this.form.id_modalidades_envio = 3
            break
          case 'consolidado':
            this.form.id_modalidades_envio = 2
            this.form.precio_original = this.costoTotal
            this.form.precio_servicio = this.costoTotal
            break
          case 'aereo':
            this.form.id_modalidades_envio = 4
            this.form.precio_original = this.costoTotal
            this.form.precio_servicio = this.costoTotal
            break
        }
        this.form.paquetes = this.paquetes

        if (this.envioId) {
          response = await axios.put(`envios/${this.envioId}`, this.form)

          Swal.fire({
            icon: 'success',
            title: 'Envío Actualizado',
            text: 'Los datos se han actualizado correctamente.',
            confirmButtonText: 'Aceptar'
          }).then(() => {
            router.push('/listado-envios/mercaderia');
          });
        } else {
          response = await axios.post('envios', this.form)
          this.pedidoResponse = response.data

          Swal.fire({
            icon: 'success',
            title: 'Envío Guardado',
            html: `Los datos se han guardado correctamente.<br><strong>Su número de rastreo es: ${this.pedidoResponse.rastreo}</strong>`,
            confirmButtonText: 'Aceptar'
          }).then(() => {
            router.push('/listado-envios/mercaderia');
          });
        }
      } catch (error) {
        console.error(error)

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al registrar el envío.',
        })
      }
    },
  }
}

</script>

<style scoped>
.form-group {
  margin-bottom: 10px;
  margin-top: 10px;
}

/* ── Cards ── */
.bg-card {
  background-color: #fff !important;
  border: 1px solid #e8eaf6;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(63,81,181,0.07);
}
.bg-card .card-header {
  background: linear-gradient(90deg, #3f51b5 0%, #5c6bc0 100%) !important;
  color: #fff !important;
  font-weight: 700;
  font-size: 0.9rem;
  border-radius: 9px 9px 0 0 !important;
  padding: 11px 18px;
  border-bottom: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Labels ── */
label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #546e7a;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
}
label.required::after {
  content: ' *';
  color: #e53935;
}

/* ── Inputs ── */
.form-control, .form-select {
  font-size: 0.85rem;
  border-color: #e0e0e0;
  border-radius: 6px;
}
.form-control:focus, .form-select:focus {
  border-color: #5c6bc0;
  box-shadow: 0 0 0 0.2rem rgba(63,81,181,0.12);
}
.form-control:disabled, .form-control[readonly] {
  background: #f5f6ff;
  color: #546e7a;
}

/* ── Misc ── */
.font-small { font-size: 0.9rem; }
.col-lg-21 { width: 12.5%; }
.hover-pointer { cursor: pointer; }
.no-resize { resize: none; }
.table-font-small { font-size: 0.75rem; }

thead th, tbody tr { text-align: center; }

/* ── Modal header ── */
.modal-title { color: #fff !important; }
.btn-close { filter: invert(1); }

@media (min-width: 1200px) and (max-width: 1400px) {
  .col-lg-2 { width: 25%; }
}
</style>
